import ConfigForm from './ConfigForm.jsx';

const SCHEMA = [
  { key: 'placeholder', label: 'Placeholder', kind: 'text' },
  { key: 'min', label: 'Min', kind: 'number' },
  { key: 'max', label: 'Max', kind: 'number' },
  { key: 'step', label: 'Step', kind: 'number' },
  { key: 'integer', label: 'Integer only', kind: 'boolean' },
];

export default function NumberConfig({ field, onConfigChange }) {
  return <ConfigForm schema={SCHEMA} config={field.config} onConfigChange={onConfigChange} />;
}
